import PassengerSegList from './PassengerSegList.vue'
import { Checkbox, Popover, Spin, Modal } from 'ant-design-vue'
import moment from 'moment'
import codeMask from '@/assets/js/codeMask'

/* istanbul ignore next */
PassengerSegList.install = function (Vue) {
  Vue.component(PassengerSegList.name, PassengerSegList)
  Vue.use(Checkbox)
  Vue.use(Popover)
  Vue.use(Spin)
  Vue.prototype.$modal = Modal
  Vue.prototype.moment = moment

  Vue.filter('ruleFee', (value, txt = '-', name = 'amount') => {
    if (!value) {
      return txt
    }

    let val = value - 0

    if (isNaN(val)) {
      return value
    }

    if (val > 0) {
      return name === 'amount' ? `${val}元/人` : `${val * 100}%`
    }

    return txt
  })

  Vue.filter('amount', (value, dep = 2) => {
    if (!value) {
      return value
    } else {
      return (+value).toFixed(dep)
    }
  })

  Vue.filter('codeMask', (value, options) => {
    return codeMask(value, options)
  })
}

export default PassengerSegList
